import { select, call, spawn, put, take } from 'redux-saga/effects';
import * as Env from '@/domain/env';
import { doLogout } from '@/domain/api';
import { ensureGetOrganization, ensureGetOrganizationList } from '@/domain/organization/sagas';
import { signInAction } from '@/domain/env';

import { getRuntimeConfig } from '@/lib/runtimeConfig';
import { navigate } from '@/domain/router/redux/reduxActions';
import ROUTES_PATH from '@/router/routesPathConfig';
import { generatePath } from 'react-router-dom';

function* initFreshDesk() {
  const locale = yield select(Env.localeSelector);
  // freshworks setup.
  // must be iniitialized before widget script is loaded
  // in Header component
  window.fwSettings = {
    widget_id: getRuntimeConfig().env.REACT_APP_FRESHDESK_WIDGET_ID,
    locale,
  };

  // eslint-disable-next-line
  !(function (...args) {
    if (typeof window.FreshworksWidget !== 'function') {
      console.log('freshDesk parameters initialized');
      // eslint-disable-next-line
      var n = function () {
        n.q.push(args);
      };
      // eslint-disable-next-line
      (n.q = []), (window.FreshworksWidget = n);
    }
  })();
}

function* ensureOrganization() {
  yield call(initFreshDesk);
  const isAuthorized = yield select(Env.isAuthorizedSelector);
  const isDokkaSupport = yield select(Env.isDokkaSupportSelector);

  if (isAuthorized) {
    try {
      // if ghost - redirect to org list
      const defaultGhostURL = generatePath(ROUTES_PATH.ORGANIZATIONS.absolute);
      const currentUrl = window.location.pathname;
      if (isDokkaSupport && currentUrl === '/') {
        yield put(navigate.replace(defaultGhostURL, {}));
      }
      yield call(ensureGetOrganization);
      yield call(ensureGetOrganizationList);
    } catch (err) {
      yield doLogout(signInAction, err);
    }
  } else {
    yield take(signInAction.success);
    yield call(ensureGetOrganization);
  }
}

export default function* organization() {
  yield spawn(ensureOrganization);
}
